export const insertionCollision = ({ collisionRect, droppableRects, droppableContainers, active }) => {
  const collisions = [];

  const sameTypeContainers = droppableContainers
    .filter((container) => container.data?.current?.type === active.data?.current?.type);

  for (const droppableContainer of sameTypeContainers) {
    const { id } = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect) {
      const dy = collisionRect.top - rect.top;
      const dx = Math.min(Math.abs(collisionRect.left - rect.left), Math.abs(collisionRect.left - rect.right));
      const position = (collisionRect.left + (collisionRect.width / 2)) < (rect.left + (rect.width / 2))
        ? 'before'
        : 'after';

      const distanceRatio = Math.abs(dy) + Math.abs(dx) * 0.05;
      collisions.push({
        id,
        data: { droppableContainer, distanceRatio, position },
      });
    }
  }

  return collisions.sort((a, b) => a.data?.distanceRatio - b.data?.distanceRatio);
};
